import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { auctioneerDataTemplatePropertiesType, auctioneerDataTemplateType } from '../../types';
import useDetailHandler from '../../hooks/useDetailHandler';
import { onActionKey } from '../../utils';
import AuctioneerDataTemplateDetailTab from './AuctioneerDataTemplateDetailTab';
import './_styles_/AuctioneerDataTemplateRow.css';

AuctioneerDataTemplateRow.propTypes = {
    auctioneerDataTemplate: auctioneerDataTemplateType.isRequired,
    auctioneerDataTemplateProps: auctioneerDataTemplatePropertiesType.isRequired,
    onUpload: PropTypes.func.isRequired,
};

function AuctioneerDataTemplateRow(props) {
    const {
        auctioneerDataTemplate,
        auctioneerDataTemplateProps,
        onUpload,
    } = props;
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(auctioneerDataTemplate.id);
    return (
        <>
            <div className="rich-list-row auctioneer-data-template-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="auctioneer-data-template-header--values--id">{auctioneerDataTemplate.id}</div>
                <div className="auctioneer-data-template-header--values--name">{auctioneerDataTemplate.name}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <AuctioneerDataTemplateDetailTab
                    auctioneerDataTemplate={auctioneerDataTemplate}
                    auctioneerDataTemplateProps={auctioneerDataTemplateProps}
                    onDetailDelete={onDetailDelete}
                    onUpload={onUpload}
                />
            )}
        </>
    );
}

export default AuctioneerDataTemplateRow;
